export enum AutoResolvedReasonLineVariant {
  LIST = 'LIST',
  BOARD = 'BOARD',
  MODAL = 'MODAL',
}
